import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CloseOutlineSVG = function CloseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M17.41 16l12.3-12.29a1 1 0 10-1.42-1.42L16 14.59 3.71 2.29a1 1 0 00-1.42 1.42L14.59 16 2.29 28.29a1 1 0 000 1.42 1 1 0 001.42 0L16 17.41l12.29 12.3a1 1 0 001.42 0 1 1 0 000-1.42z"
  }));
};
CloseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CloseOutlineSVG);